import React from "react";
import "../../assets/css/suggestion-list.css";
// import Loader from "./loaderOnlySpinner";

function CustomUniversityDropDown({ optionData, classes, selectOption }) {
  // console.log("opt", optionData);

  return (
    <>
      <div className={`filteredCompany w-100 ${classes ? classes : ""}`}>
      {optionData.length !== 0 &&
        <ul style={{width: 'inherit'}}> 
          {optionData &&
            optionData.map((value, index) => {
              // console.log(value);
              return (
                <li
                  key={index}
                  onClick={() =>
                    selectOption({ value: value.value, name: value.label })
                  }
                  data-value={value.value}
                >
                  {value.label}
                </li>
              );
            })}
        </ul>
}
      </div>
    </>
  );
}

export default CustomUniversityDropDown;
